<script>
import {API2_URL} from "api-client";
import {mapGetters} from "vuex";
import axios from "axios";
import {resolveValue} from "@/utils/CommonLogic";

export default {
  name: "PaymentDetails",
  data() {
    return {
      registrationStatus: undefined,
      debitCard: undefined,
      remainingDays: 0,
      contracts: [],
      contractTypes: [
        {'name': 'Könyvelési szerződés', id: 'ACCOUNTING' },
        {'name': 'Újrakönyvelési szerződés', id: 'RE_ACCOUNTING' },
        {'name': 'Egyedi adóbevallás', id: 'INDIVIDUAL_TAX_RETURN' },
        {'name': 'SZJA szerződés', id: 'SZJA' },
        {'name': 'Végelszámolási szerződés', id: 'FINAL_SETTLEMENT' },
      ],
      paymentModes: [
        {'name': 'Bankkártya', id: 'CREDIT_CARD' },
        {'name': 'Átutalás', id: 'TRANSFER' },
        {'name': 'Készpénz', id: 'TRANSFER' },
      ],
    }
  },
  methods: {
    isPWAMode() {
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    },

    resolveValue,

    redirectForDebitCardRegistration() {
      const url = API2_URL + `/subscription/initiate-debit-card-registration/${this.getActiveCompany.id}`
      axios.get(url)
        .then(resp => {
          window.location.replace(resp.data.url);
        })
        .catch(err => {
          console.error(err);
          this.$toast.error({
            title: this.$cte("common.error"),
            message: this.$cte("common.error"),
          });
        });
    },

    deleteDebitCard() {
      const url = API2_URL + `/subscription/connected-card/${this.getActiveCompany.id}`
      axios.delete(url)
          .then(() => {
            this.$toast.success({
              title: this.$cte("toast.success"),
            });
            window.location.reload();
          })
          .catch(err => {
            console.error(err);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("common.error"),
            });
          });
    },

    // pay(contractId){
    //   axios.post(API2_URL + `/subscription/accept-contract-payment`, {companyId: this.getActiveCompany.id, contractId: contractId} )
    //     .then(() => {
    //       this.$toast.success({
    //         title: this.$cte("toast.success"),
    //         message: this.$cte("toast.add-success"),
    //       });
    //       this.loadApprovals();
    //     })
    //     .catch(err => {
    //       console.error(err);
    //       this.$toast.error({
    //         title: this.$cte("common.error"),
    //         message: this.$cte("common.error"),
    //       });
    //     });
    // },

    loadApprovals() {
      axios.get(API2_URL + `/subscription/invoice-approvals/${this.getActiveCompany.id}`)
          .then(resp => {
            this.contracts = resp.data;
          })
          .catch(err => {
            console.error(err);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("common.error"),
            });
          });
    }
  },
  mounted() {
    axios.get(API2_URL + `/subscription/has-debit-card-registration/${this.getActiveCompany.id}`)
      .then(resp => {
        this.registrationStatus = resp.data;
        if (this.registrationStatus === 'REGISTERED') {
          axios.get(API2_URL + `/subscription/connected-card/${this.getActiveCompany.id}`)
            .then(resp2 => {
              this.debitCard = resp2.data;
            }).catch(err => {
              console.error(err);
              this.$toast.error({
                title: this.$cte("common.error"),
                message: this.$cte("common.error"),
              });
            });
        }
      })
      .catch(err => {
        console.error(err);
        this.$toast.error({
          title: this.$cte("common.error"),
          message: this.$cte("common.error"),
        });
      });

    axios.get(API2_URL + `/subscription/remaining-trial-days/${this.getActiveCompany.id}`)
      .then(resp => {
        this.remainingDays = resp.data;
      })
      .catch(err => {
        console.error(err);
        this.$toast.error({
          title: this.$cte("common.error"),
          message: this.$cte("common.error"),
        });
      });

    this.loadApprovals();

  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  }
}
</script>

<template>
  <div>
    <b-modal id="connectModal" title="Bankkártya megadása">
      <div class="font-poppins">
        <p>Nagyszerű!</p>
        <p>Úgy döntöttél, hogy bankkártyával egyenlíted ki szolgáltatásunk díját.</p>
        <p>
          <small>Most átirányítunk a Barion felületére, ahol megadhatod bankkártyaadataidat. A kártya érvényességének ellenőrzése érdekében 100 Ft-tal megterheljük. A sikeres ellenőrzés után az összeget azonnal visszautaljuk, majd megkezdődik a szolgáltatási díj terhelése.</small>
        </p>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="success" @click="redirectForDebitCardRegistration">Tovább</b-button>
      </template>
    </b-modal>
    <b-modal id="deleteModal" title="Bankkártya törlése">
      <div class="font-poppins">
        <p>Biztos törlöd a bankkártyádat? Amennyiben továbbra is bankkártyával szeretnéd fizetni a szolgáltatás díját, kérlek állítsd be új bankkártyát!</p>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="success" @click="deleteDebitCard">Igen</b-button>
      </template>
    </b-modal>
    <b-row v-if="remainingDays >= 0 && contracts.length == 0">
      <b-col>
        <b-alert variant="secondary" show dismissible>
          <h4>Még <span>{{ remainingDays }}</span> nap van hátra az ingyenes időszakból.</h4>
          <div>
            Reméljük, hogy eddig elégedett vagy az ingyenes próbaverzió használatával és hasznosnak találod az alkalmazásunkat. Amennyiben továbbra is szeretnéd élvezni a szolgáltatásainkat, szerződj velünk még ma!
          </div>
        </b-alert>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <b-card-group deck>
          <b-card lg="6" md="12" title="Kedves Ügyfelünk!">
            <div class="font-poppins">
              <p>Örömmel értesítünk, hogy szolgáltatásainkat még kényelmesebbé tettük. Mostantól minden szerződésedet elérheted a felületünkön, és bankkártyás fizetési mód választása esetén lehetőséged van mindegyiket egyetlen gombnyomással kiegyenlíteni. Ehhez csak be kell állítanod a bankkártyádat. Számláidat eddig átutalással rendezted, de szeretnél bankkártyára váltani?</p>
              <p><small>Keresd ügyélszolgálatunkat a <a href="mailto:hello@acounto.com">hello@acounto.com</a>-on és jelezd felénk módosítási igényedet!</small></p>
            </div>
          </b-card>
          <b-card lg="6" md="12" title="Bankkártyám">
            <b-row class="pt-3">
              <b-col class="">
                <div v-if="debitCard && debitCard.maskedPan !== null">
                  <div class="p-3 creditCard" style="color: #FCFCFC; background: var(--Card-gradient-4, linear-gradient(90deg, #000 0%, #434343 100%));">
                    <div class="mb-4 text-right">
                      <img src="@/assets/img/visa_logo.svg" height="16" v-if="debitCard.cardType === 'VISA'">
                      <img src="@/assets/img/mastercard_logo.svg" height="16" v-if="debitCard.cardType === 'MASTER_CARD'">
                      <img src="@/assets/img/maestro_logo.svg" height="16" v-if="debitCard.cardType === 'MAESTRO'">
                      <img src="@/assets/img/amex_logo.svg" height="16" v-if="debitCard.cardType === 'AMEX'">
                    </div>
                    <div class="mb-2">
                      <small>{{ debitCard.expiryMonth }}/{{ debitCard.expiryYear }}</small>
                    </div>
                    <div>**** **** **** {{ debitCard.maskedPan }}</div>
                  </div>
                </div>
                <div v-else>
                  <div class="p-3 creditCard" style="">
                    <div class="mb-4 text-right">
                      <div style="width: 60px; height: 40px; border-radius: 6px; background-color: #eee;"></div>
                    </div>
                    <div class="text-muted mb-2">
                      <small>**/**</small>
                    </div>
                    <div>**** **** **** ****</div>
                  </div>
                </div>
              </b-col>
              <b-col class="d-flex align-items-end justify-content-center">
                <div v-if="isPWAMode()" class="mt-4">Bankkártya bekötéséhez vagy módosításához kérlek, nyisd meg az alkalmazást böngészőben.</div>
                <div v-else>
                  <div v-if="debitCard && debitCard.maskedPan !== null">
                    <b-button variant="danger" class="mt-5 btn-sm-block" style="padding-left: 50px !important; padding-right: 50px !important;" @click="$bvModal.show('deleteModal')">Bankkártya törlése</b-button>
                    <b-button variant="primary" class="mt-3 btn-sm-block" @click="$bvModal.show('connectModal')">Bankkártya lecserélése</b-button>
                  </div>
                  <b-button v-else variant="primary" class="mt-5" @click="$bvModal.show('connectModal')">Bankkártya megadása</b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card title="Szerződéseim" class="">
          <div class="p-3" v-if="contracts">
            <div v-for="(contract, index) in contracts" :key="index">
              <b-row v-if="contract.enabled" class="p-2 mb-2" style="border-radius: 16px; border: 1px solid gray;">
                <b-col lg="4" md="12">
                  <div>{{ resolveValue(contractTypes, contract.contractType) }}<span v-if="contract.taxReturnType">: {{ contract.taxReturnType }}</span></div>
                  <div v-if="contract.contractType === 'ACCOUNTING'" class="small text-muted">{{ contract.startOfTheServicePeriod }}</div>
                  <div v-if="contract.contractType === 'FINAL_SETTLEMENT'" class="small text-muted">{{ contract.startOfTheServicePeriod }}</div>
                  <div v-if="contract.contractType === 'RE_ACCOUNTING'" class="small text-muted">{{ contract.startOfTheServicePeriod }} - {{ contract.endOfTheServicePeriod }}</div>
                  <div v-if="contract.contractType === 'SZJA'" class="small text-muted">{{ new Date(contract.startOfTheServicePeriod).getFullYear() }}</div>
                  <div v-if="contract.contractType === 'INDIVIDUAL_TAX_RETURN'" class="small text-muted">{{ new Date(contract.startOfTheServicePeriod).getFullYear() }}</div>
                </b-col>
                <b-col lg="2" md="12">
                  <div>{{ contract.price }} Ft + ÁFA <span v-if="contract.contractType === 'ACCOUNTING'">/ hó</span></div>
                  <div class="small text-muted">{{ contract.pricePlanName }}</div>
                </b-col>
                <b-col lg="2" md="12">
                  {{ resolveValue(paymentModes, contract.paymentMode) }}
                </b-col>
                <b-col lg="2" md="12">
                  <div>Státusz</div>
                  <div class="small text-muted">{{ contract.contractStatus === 'SIGNED' ? 'Aláírva' : 'A szerződés aláírásra vár' }}</div>
                </b-col>
                <b-col lg="2" md="12" class="text-right">
                  <div v-if="contract.paymentMode === 'CREDIT_CARD'">
                    <div v-if="contract.status === 'OK'" class="pt-2"><i class="fal fa-2x fa-circle-check text-success"></i></div>
                    <div v-if="contract.status === 'HAS_ISSUE'" class="pt-2"><i class="fal fa-2x fa-circle-exclamation-check text-danger"></i></div>
                    <div v-if="contract.status === 'NEED_TO_BE_SIGNED'" class="pt-2"><i class="fal fa-2x fa-circle-exclamation text-danger"></i></div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-card class="text-center bg-white">
          <img src="@/assets/img/barion_logos.png" class="img-fluid">
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.creditCard {
  width: 300px;
  height: 200px;
  border: 1px solid #eee;
  border-radius: 16px;
}
@media (max-width: 768px) {
  .creditCard {
    width: 100% !important;
  }
}
</style>